import React, { useEffect, useState, useCallback, useRef } from 'react';
import ListItem from './ListItem';
import ListingModal from './ListingModal';
import {
  Row,
  Col,
  Button,
  ButtonGroup,
  OverlayTrigger,
} from 'react-bootstrap';
import axios from 'axios';
import MapContainer from './MapContainer';
import FilterPopover from './FilterPopover';
import _ from 'lodash';
import 'react-day-picker/lib/style.css';
import { doFiltering } from '../util/Helper';
import 'moment/locale/it';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const Listings = (props) => {
  // Getter and setter for user state
  const [dynamicAmenities, setDynamicAmenities] = useState([]);
  const [dynamicUtilities, setDynamicUtilities] = useState([]);
  const [dynamicRoommateAttributes, setDynamicRoommateAttributes] = useState([]);
  const [unitTypes, setUnitTypes] = useState([]);
  const [numOfRooms, setNumOfRooms] = useState([]);
  const [leaseTermTypes, setLeaseTermTypes] = useState([]);
  const [locationGroups, setLocationGroups] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [utilities, setUtilities] = useState([]);
  const [roommates, setRoommates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedListing, setSelectedListing] = useState({});
  const [isMapView, setIsMapView] = useState(true);
  const [distanceType, setDistanceType] = useState('mile');

  let filteredMarkers = '';

  const filterHousing = (filterBy, filterFor) => {
    const filter = { ...props.filters };
    filter[filterFor] = filterBy;
    props.setFilters(filter);
  };

  const resetFilters = () => {
    const filter = { ...props.filters };
    Object.keys(filter).map(e => filter[e] = '');
    props.setFilters(filter);
  }
  const delayedQuery = useCallback(
    _.debounce((q, v) => filterHousing(q, v), 700),
    []
  );

  const popoverBottom = (
    <FilterPopover
      filterHousing={filterHousing}
      filters={props.filters}
      delayedQuery={delayedQuery}
      resetFilters={resetFilters}
      amenities={amenities}
      utilities={utilities}
      roommates={roommates}
      numOfRooms={numOfRooms}
      unitTypes={unitTypes}
      locationGroups={locationGroups}
      leaseTermTypes={leaseTermTypes}
      dynamicAmenities={dynamicAmenities}
      dynamicUtilities={dynamicUtilities}
      dynamicRoommateAttributes={dynamicRoommateAttributes}
      distanceType={distanceType}
      setDistanceType={setDistanceType}
    />
  );

  const itemSelect = (listing) => {
    setSelectedListing(listing);
    setShowModal(true);
  };

  const ref = useRef(null);

  const addDynamicVar = (variable, dynamicVar) => {
    let dynamicObj = {
      'key': _.camelCase(variable),
      'value' : variable
    }
    dynamicVar.push(dynamicObj);
  }

  useEffect(() => {
    const getHousing = async () => {
      let allAmenities = [];
      let allUtilities = [];
      let allRoommates = [];
      let allUnitTypes = [];
      let allNumOfRooms = [];
      let allLocationGroups = [];
      let allLeaseTypes = [];
      let dynamicAmenitiesVars = [];
      let dynamicUtilitiesVars = [];
      let dynamicRoommateAttributesVars = [];
      const { data } = await axios.post(
        process.env.REACT_APP_API_GRAPHQL,
        {
          query: `
            {listings 
              {
                listingId,
                title, 
                rent,
                roomsForRent,
                bedroomCount,
                dateAvailable,
                unitTypeTitle,
                leaseTypeTitle,
                listingAddress,
                latitude,
                longitude,
                roommateAttributes,
                amenities,
                utilities,
                contactPhone,
                distanceFromCampus,
                locationGroupTitle,
                photos {title, imageUrl}
              }
            }`,
        }
      );
      setMarkers(data.data.listings);

      allUnitTypes = [...new Set(data.data.listings.map(item => item.unitTypeTitle))].sort();
      allNumOfRooms = [...new Set(data.data.listings.map(item => item.bedroomCount))].sort();
      allLocationGroups = [...new Set(data.data.listings.filter(item => item.locationGroupTitle !== null).map(item => item.locationGroupTitle))].sort();
      allLeaseTypes = [...new Set(data.data.listings.map(item => item.leaseTypeTitle))].sort().reverse();
       
      data.data.listings.forEach((listing) => {
        if (listing.amenities) {
          listing.amenities.forEach((amenity) => {
            if (allAmenities.indexOf(amenity) === -1 ) { 
              allAmenities.push(amenity); 
              addDynamicVar(amenity, dynamicAmenitiesVars); 
            }
          });
        }
        if (listing.utilities) {
          listing.utilities.forEach((utility) => {
            if (allUtilities.indexOf(utility) === -1 ) { 
              allUtilities.push(utility); 
              addDynamicVar(utility, dynamicUtilitiesVars); 
            }
          });
        }
        if (listing.roommateAttributes) {
          listing.roommateAttributes.forEach((roommate) => {
            if (allRoommates.indexOf(roommate) === -1 ) { 
              allRoommates.push(roommate); 
              addDynamicVar(roommate, dynamicRoommateAttributesVars); 
            }
          });
        }

        setAmenities(allAmenities);
        setUtilities(allUtilities);
        setRoommates(allRoommates);
        setDynamicAmenities(dynamicAmenitiesVars);
        setDynamicUtilities(dynamicUtilitiesVars);
        setDynamicRoommateAttributes(dynamicRoommateAttributesVars);
        setNumOfRooms(allNumOfRooms);
        setUnitTypes(allUnitTypes);
        setLocationGroups(allLocationGroups);
        setLeaseTermTypes(allLeaseTypes);
      });
    };

    getHousing();
  }, []);

  filteredMarkers = markers;

  if (Array.isArray(markers) && props.filters) {
      filteredMarkers = doFiltering(filteredMarkers, props.filters, dynamicAmenities, dynamicUtilities, dynamicRoommateAttributes, distanceType);
  }

  return Array.isArray(filteredMarkers) ? ( 
  <>
  <div class="container-full map">
  <h1 class="navbar-brand visible-lg">Off-Campus Housing Listings</h1>
  
  <ul class="utility-nav map">
    <li className='utility-nav-item'> <a href="https://mankato.mnsu.edu/university-life/housing/off-campus-housing/"><FontAwesomeIcon icon={faInfoCircle} /> <span className="hidden-sm hidden-xs">More information</span></a></li>
  <li><OverlayTrigger
                          trigger='click'
                          placement='bottom'
                          overlay={popoverBottom}
                          container={ref.current}
                          containerPadding={20}
                          rootClose
                        >
                          <a ref={ref} role="button" href="#">Filter Listings</a>
                        </OverlayTrigger></li>
    <li><a href="#" onClick={(evt) => {
                            evt.preventDefault();
                            setIsMapView(!isMapView);
                          }}
                        >
                          {isMapView ? 'List View' : 'Map View'}</a></li>
 

</ul>
    </div>
      {isMapView && (
        <main className='col-md-9' id='mainContent'>
          <div id='mapContainer'>
            <MapContainer
              listings={filteredMarkers}
              itemSelect={itemSelect}
              containerElement={
                <div className='containerElement'></div>
              }
              mapElement={<div className='mapElement'></div>}
            />
          </div>
        </main>
      )}
      <Col
        md={isMapView ? 3 : 12}
        className='container default'
        aria-expanded='true'
        style={({ right: `0px`}, { backgroundColor: `#ffffff` })}
      >
        <div className='menu-wrapper'>
          <Row>
            <Col lg={12} data-side='right'>
              <div className='l-group'>
                <div className='l-group-item'>     
                    <h2 className='h4 listingTop'><div id='resultCount'>Number of Units Available: {filteredMarkers.length}</div></h2>     
                  <hr />
                </div>
                <div
                  className={
                    isMapView
                      ? 'block-grid-md-1 block-grid-lg-1 viewWindow'
                      : 'block-grid-xs-1 block-grid-sm-2 block-grid-md-3 block-grid-lg-4 viewWindow'
                  }
                >
                  {filteredMarkers.map((val, index) => (
                    <div key={index}>
                      <ListItem
                        listing={val}
                        key={index}
                        itemSelect={itemSelect}
                        title={val.title}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <ListingModal showModal={showModal} setShowModal={setShowModal} selectedListing={selectedListing} />

    </>
  ) : (
    <div>Loading...</div>
  );
};

export default Listings;
